// Shared time-off "type" metadata and reusable UI.
//
// type ids: 0 VACATION, 1 SICK, 2 MEDICAL APPOINTMENT, 3 OTHER.
//
// Exports:
//   TYPE_META          - the per-type config map (colors, labels, icon).
//   TimeOffTypeIcon    - just the type's icon, sized + colored.
//   TimeOffTypeBadge   - the icon + label pill.

// Each icon renders the design-spec SVG, inherits its color from the
// `currentColor` fill (set via the surrounding `text-*` / iconClass), and
// accepts a `size` prop so callers can render it at any size.
const iconProps = ({ size = 12, className = "" }) => ({
  width: size,
  height: size,
  className,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
});

const VacationIcon = (props) => (
  <svg {...iconProps(props)} viewBox="0 0 12 12">
    <path d="M9.35828 1.14152C9.78166 1.01125 10.2351 0.98214 10.5966 1.13224L10.6674 1.16447L10.7191 1.19572C10.7681 1.23099 10.8081 1.27794 10.8353 1.33244C11.0212 1.70431 10.9972 2.19001 10.8583 2.64152C10.7151 3.10682 10.4328 3.59728 10.015 4.01505L8.41003 5.61954L9.26599 9.51945L9.26746 9.52628C9.35107 9.94435 9.16713 10.2807 8.87488 10.4999C8.84854 10.5197 8.81951 10.536 8.78894 10.5483L8.53894 10.6479C8.16469 10.7975 7.72173 10.737 7.45007 10.3749C7.44558 10.3689 7.44101 10.3626 7.43689 10.3564L5.89441 8.02042L4.87488 8.7006V9.99992C4.87488 10.0994 4.83534 10.1947 4.76501 10.2651L4.26501 10.7651C4.18557 10.8445 4.07457 10.884 3.96277 10.873C3.85103 10.8618 3.75015 10.8014 3.68787 10.7079L2.72937 9.26993L1.29187 8.31193C1.19844 8.24964 1.13795 8.14876 1.12683 8.03702C1.11576 7.92522 1.1553 7.81422 1.23474 7.73478L1.73474 7.23478L1.79187 7.1879C1.85302 7.14714 1.9253 7.12492 1.99988 7.12492H3.29919L3.97888 6.1049L1.64343 4.5629C1.63719 4.55878 1.63086 4.55421 1.62488 4.54972C1.26276 4.27807 1.20227 3.8351 1.35193 3.46085L1.3783 3.40714L1.5282 3.15714C1.70158 2.83528 2.03239 2.67467 2.39783 2.72013L2.47351 2.73234L2.48035 2.7338L6.37976 3.58927L7.98474 1.98478C8.40252 1.567 8.89298 1.2847 9.35828 1.14152ZM10.2045 1.79533C10.0593 1.76828 9.84553 1.77631 9.57898 1.85831C9.2318 1.96514 8.84722 2.18285 8.51501 2.51505L6.76501 4.26505C6.6746 4.35547 6.54421 4.39354 6.41931 4.36613L2.32654 3.46769L2.28796 3.46232C2.2548 3.46039 2.23608 3.46709 2.22742 3.47111C2.21671 3.4761 2.20082 3.48677 2.18542 3.51749C2.18113 3.52608 2.1762 3.53465 2.17126 3.54288L2.04138 3.7587C2.02242 3.81447 2.02303 3.85579 2.02869 3.88126C2.03399 3.90495 2.04549 3.92601 2.07068 3.9462L4.70642 5.68693C4.78965 5.74189 4.84778 5.82794 4.86755 5.9257C4.88728 6.02341 4.86719 6.12498 4.81189 6.20792L3.81189 7.70792C3.74234 7.81225 3.62526 7.87492 3.49988 7.87492H2.15515L2.08826 7.94132L3.20789 8.6879L3.26501 8.73478C3.28243 8.7522 3.29816 8.77131 3.31189 8.79191L4.05798 9.91105L4.12488 9.84464V8.49992C4.12488 8.37453 4.18754 8.25745 4.29187 8.1879L5.79187 7.1879L5.8573 7.15324C5.92543 7.12522 6.00082 7.11745 6.0741 7.13224C6.17186 7.15201 6.2579 7.21014 6.31287 7.29337L8.0531 9.92863C8.07343 9.95419 8.09468 9.96576 8.11853 9.97111C8.14686 9.9774 8.19499 9.97783 8.26062 9.95158L8.45837 9.87247C8.53571 9.80403 8.5466 9.74576 8.5321 9.67325L7.63367 5.58048C7.60625 5.45559 7.64432 5.3252 7.73474 5.23478L9.48474 3.48478C9.81694 3.15258 10.0347 2.76799 10.1415 2.42081C10.2235 2.15426 10.2315 1.94051 10.2045 1.79533Z" />
  </svg>
);

const SickIcon = (props) => (
  <svg {...iconProps(props)} viewBox="0 0 11 9">
    <path d="M0 8.375V0.375C0 0.167893 0.167893 0 0.375 0C0.582107 0 0.75 0.167893 0.75 0.375V8.375C0.75 8.58211 0.582107 8.75 0.375 8.75C0.167893 8.75 0 8.58211 0 8.375Z" />
    <path d="M10 8.375V3.375C10 3.20924 9.9341 3.05032 9.81689 2.93311C9.69968 2.8159 9.54076 2.75 9.375 2.75H0.375C0.167893 2.75 0 2.58211 0 2.375C0 2.16789 0.167893 2 0.375 2H9.375C9.73967 2 10.0893 2.14497 10.3472 2.40283C10.605 2.66069 10.75 3.01033 10.75 3.375V8.375C10.75 8.58211 10.5821 8.75 10.375 8.75C10.1679 8.75 10 8.58211 10 8.375Z" />
    <path d="M10.375 6.5C10.5821 6.5 10.75 6.66789 10.75 6.875C10.75 7.08211 10.5821 7.25 10.375 7.25H0.375C0.167893 7.25 0 7.08211 0 6.875C0 6.66789 0.167893 6.5 0.375 6.5H10.375Z" />
    <path d="M2 6.875V2.375C2 2.16789 2.16789 2 2.375 2C2.58211 2 2.75 2.16789 2.75 2.375V6.875C2.75 7.08211 2.58211 7.25 2.375 7.25C2.16789 7.25 2 7.08211 2 6.875Z" />
  </svg>
);

const MedicalIcon = (props) => (
  <svg {...iconProps(props)} viewBox="0 0 11 11">
    <path d="M4.5 1.375V0.375C4.5 0.167893 4.66789 0 4.875 0C5.08211 0 5.25 0.167893 5.25 0.375V1.375C5.25 1.58211 5.08211 1.75 4.875 1.75C4.66789 1.75 4.5 1.58211 4.5 1.375Z" />
    <path d="M1.5 1.375V0.375C1.5 0.167893 1.66789 0 1.875 0C2.08211 0 2.25 0.167893 2.25 0.375V1.375C2.25 1.58211 2.08211 1.75 1.875 1.75C1.66789 1.75 1.5 1.58211 1.5 1.375Z" />
    <path d="M0 3.875V1.875C0 1.51033 0.144969 1.16069 0.402832 0.902832C0.660695 0.644969 1.01033 0.5 1.375 0.5H1.875C2.08211 0.5 2.25 0.667893 2.25 0.875C2.25 1.08211 2.08211 1.25 1.875 1.25H1.375C1.20924 1.25 1.05032 1.3159 0.933105 1.43311C0.815895 1.55032 0.75 1.70924 0.75 1.875V3.875C0.75 4.57119 1.02676 5.23867 1.51904 5.73096C2.01133 6.22324 2.67881 6.5 3.375 6.5C4.07119 6.5 4.73867 6.22324 5.23096 5.73096C5.72324 5.23867 6 4.57119 6 3.875V1.875C6 1.70924 5.9341 1.55032 5.81689 1.43311C5.69968 1.3159 5.54076 1.25 5.375 1.25H4.875C4.66789 1.25 4.5 1.08211 4.5 0.875C4.5 0.667893 4.66789 0.5 4.875 0.5H5.375C5.73967 0.5 6.08931 0.64497 6.34717 0.902832C6.60503 1.16069 6.75 1.51033 6.75 1.875V3.875C6.75 4.77011 6.39465 5.62878 5.76172 6.26172C5.12878 6.89465 4.27011 7.25 3.375 7.25C2.47989 7.25 1.62122 6.89465 0.988281 6.26172C0.355346 5.62878 0 4.77011 0 3.875Z" />
    <path d="M3 6.875C3 6.66789 3.16789 6.5 3.375 6.5C3.58211 6.5 3.75 6.66789 3.75 6.875C3.75 7.57119 4.02676 8.23867 4.51904 8.73096C5.01133 9.22324 5.67881 9.5 6.375 9.5C7.07119 9.5 7.73867 9.22324 8.23096 8.73096C8.72324 8.23867 9 7.57119 9 6.875V5.375C9 5.16789 9.16789 5 9.375 5C9.58211 5 9.75 5.16789 9.75 5.375V6.875C9.75 7.77011 9.39465 8.62878 8.76172 9.26172C8.12878 9.89465 7.27011 10.25 6.375 10.25C5.47989 10.25 4.62122 9.89465 3.98828 9.26172C3.35535 8.62878 3 7.77011 3 6.875Z" />
    <path d="M10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375C8.75 4.72018 9.02982 5 9.375 5C9.72018 5 10 4.72018 10 4.375ZM10.75 4.375C10.75 5.13439 10.1344 5.75 9.375 5.75C8.61561 5.75 8 5.13439 8 4.375C8 3.61561 8.61561 3 9.375 3C10.1344 3 10.75 3.61561 10.75 4.375Z" />
  </svg>
);

const OtherIcon = (props) => (
  <svg {...iconProps(props)} viewBox="0 0 10 11">
    <path d="M2.5 2.375V0.375C2.5 0.167893 2.66789 0 2.875 0C3.08211 0 3.25 0.167893 3.25 0.375V2.375C3.25 2.58211 3.08211 2.75 2.875 2.75C2.66789 2.75 2.5 2.58211 2.5 2.375Z" />
    <path d="M6.5 2.375V0.375C6.5 0.167893 6.66789 0 6.875 0C7.08211 0 7.25 0.167893 7.25 0.375V2.375C7.25 2.58211 7.08211 2.75 6.875 2.75C6.66789 2.75 6.5 2.58211 6.5 2.375Z" />
    <path d="M9 2.375C9 2.02982 8.72018 1.75 8.375 1.75H1.375C1.02982 1.75 0.75 2.02982 0.75 2.375V9.375C0.75 9.72018 1.02982 10 1.375 10H8.375C8.72018 10 9 9.72018 9 9.375V2.375ZM9.75 9.375C9.75 10.1344 9.13439 10.75 8.375 10.75H1.375C0.615608 10.75 0 10.1344 0 9.375V2.375C0 1.61561 0.615608 1 1.375 1H8.375C9.13439 1 9.75 1.61561 9.75 2.375V9.375Z" />
    <path d="M9.375 4C9.58211 4 9.75 4.16789 9.75 4.375C9.75 4.58211 9.58211 4.75 9.375 4.75H0.375C0.167893 4.75 0 4.58211 0 4.375C0 4.16789 0.167893 4 0.375 4H9.375Z" />
  </svg>
);

// `shortLabel` is used in compact lists; `icon` is the SVG component and
// `iconClass` its text color; `tileClass` is the soft icon-tile background.
export const TYPE_META = {
  0: {
    label: "Vacation",
    shortLabel: "Vacation",
    className: "bg-[#EAF3FF] text-[#0058E5]",
    dotClass: "bg-[#0058E5]",
    icon: VacationIcon,
    iconClass: "text-[#0058E5]",
    tileClass: "bg-[#EAF3FF]",
  },
  1: {
    label: "Sick",
    shortLabel: "Sick",
    className: "bg-[#FFEDD5] text-[#C2410C]",
    dotClass: "bg-[#C2410C]",
    icon: SickIcon,
    iconClass: "text-[#C2410C]",
    tileClass: "bg-[#FFEDD5]",
  },
  2: {
    label: "Medical Appt.",
    shortLabel: "Medical Appt.",
    className: "bg-[#F3E8FF] text-[#7E22CE]",
    dotClass: "bg-[#7E22CE]",
    icon: MedicalIcon,
    iconClass: "text-[#7E22CE]",
    tileClass: "bg-[#F3E8FF]",
  },
  3: {
    label: "Other",
    shortLabel: "Other",
    className: "bg-[#EEF0F9] text-[#5F6477]",
    dotClass: "bg-[#5F6477]",
    icon: OtherIcon,
    iconClass: "text-[#5F6477]",
    tileClass: "bg-[#EEF0F9]",
  },
};

// Resolve a type id to its meta, falling back to "Other".
export const getTypeMeta = (type) => TYPE_META[type] || TYPE_META[3];

// The type's icon, sized and colored. Pass `colored={false}` when the icon
// should inherit color from a parent (e.g. inside a colored pill) instead of
// forcing its own `iconClass`.
export function TimeOffTypeIcon({ type, size = 12, colored = true, className = "" }) {
  const meta = getTypeMeta(type);
  const Icon = meta.icon;
  return <Icon size={size} className={`${colored ? meta.iconClass : ""} ${className}`.trim()} />;
}

// The icon + label pill. `shape` controls the corner radius and `useShortLabel`
// swaps the full label for the compact one used in dense tables.
export function TimeOffTypeBadge({
  type,
  size = 12,
  shape = "md",
  useShortLabel = false,
  className = "",
}) {
  const meta = getTypeMeta(type);
  const Icon = meta.icon;
  const radius = shape === "full" ? "rounded-full" : "rounded-md";
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 ${radius} text-[12px] font-InterSemiBold capitalize leading-[18px] tracking-[0.12px] ${meta.className} ${className}`.trim()}
    >
      <Icon size={size} className="shrink-0" />
      {useShortLabel ? meta.shortLabel : meta.label}
    </span>
  );
}
